import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import PropTypes from 'prop-types';
import CreatePost from '../CreatePost';

const FormDialog = ({open,handleClose})=> {
  return (
    <div>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <DialogContent sx={{p:0}}>
          <CreatePost handleClose={handleClose}></CreatePost>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FormDialog;

FormDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func
}